import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Nav } from "@/components/marketing/Nav";
import { Hero } from "@/components/marketing/Hero";
import { AuthModal } from "@/components/marketing/AuthModal";
import { AgentMarket } from "@/components/marketing/AgentMarket";
import {
  Cta,
  Faq,
  Features,
  Footer,
  HowItWorks,
  Vision,
} from "@/components/marketing/Sections";
import { readStoredAPIKey } from "@/lib/storage";

export default function MarketingPage() {
  const [authOpen, setAuthOpen] = useState(false);
  const navigate = useNavigate();

  const tryOpenAuth = useCallback(() => {
    if (readStoredAPIKey()) {
      navigate("/console");
      return;
    }
    setAuthOpen(true);
  }, [navigate]);

  // 进入营销页 hash 是 #console 时：已登录直接跳，否则弹 modal。
  // 与旧 setupAuthModal 行为一致。
  useEffect(() => {
    if (window.location.hash !== "#console") return;
    if (readStoredAPIKey()) {
      navigate("/console", { replace: true });
    } else {
      setAuthOpen(true);
    }
  }, [navigate]);

  return (
    <>
      <div className="noise-overlay" aria-hidden="true" />
      <Nav onOpenAuth={tryOpenAuth} />
      <Hero onOpenAuth={tryOpenAuth} />
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      <AgentMarket onOpenAuth={tryOpenAuth} />
      <Vision />
      <Features />
      <HowItWorks />
      <Faq />
      <Cta />
      <Footer />
    </>
  );
}
